import type * as SchemaTypes from '../types';

import type { CurrentUserDataFragment } from '../fragments/CurrentUserData';
import type { UploadFileWithPreviewFormDataFragment } from '../fragments/UploadFileWithPreviewFormData';
import { gql } from '@apollo/client';
import { CurrentUserDataFragmentDoc } from '../fragments/CurrentUserData';
import { UploadFileWithPreviewFormDataFragmentDoc } from '../fragments/UploadFileWithPreviewFormData';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAuthenticatedUserQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type GetAuthenticatedUserQuery = (
  { __typename: 'Query' }
  & { currentUser?: SchemaTypes.Maybe<(
    { __typename: 'User' }
    & CurrentUserDataFragment
  )> }
);


export const GetAuthenticatedUserDocument = /*#__PURE__*/ gql`
    query getAuthenticatedUser {
  currentUser {
    ...CurrentUserData
  }
}
    ${CurrentUserDataFragmentDoc}
${UploadFileWithPreviewFormDataFragmentDoc}`;

/**
 * __useGetAuthenticatedUserQuery__
 *
 * To run a query within a React component, call `useGetAuthenticatedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthenticatedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthenticatedUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthenticatedUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>(GetAuthenticatedUserDocument, options);
      }
export function useGetAuthenticatedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>(GetAuthenticatedUserDocument, options);
        }
export type GetAuthenticatedUserQueryHookResult = ReturnType<typeof useGetAuthenticatedUserQuery>;
export type GetAuthenticatedUserLazyQueryHookResult = ReturnType<typeof useGetAuthenticatedUserLazyQuery>;
export type GetAuthenticatedUserQueryResult = Apollo.QueryResult<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>;